import(/* webpackMode: "eager" */ "/app/app/partnership/_components/ActivitiesSection/ActivitiesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/partnership/_components/ExperienceWrapper/HeroSection/HeroBackground.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/partnership/_components/ExperienceWrapper/HeroSection/HeroIntro.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/partnership/_components/ExperienceWrapper/HeroSection/StorySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/partnership/_components/ExperienceWrapper/ReasonWhy/ReasonWhy.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/partnership/_components/FifaOutroSection/FifaOutroSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/partnership/_components/HistorySection/HistorySection.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/partnership/_components/OMBCSection/OMBCSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/partnership/_components/StayInspiredSection/StayInspiredSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/partnership/_components/TournamentSection/TournamentSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
